
import { type FC, useState } from 'react'

import './_confirmModal.scss'
import { useTranslation } from 'react-i18next'

import { Button } from 'components/Button/Button'
import { useModalContext } from 'context/modalContext'

type ButtonWidth = React.ComponentProps<typeof Button>['width']

const ConfirmModal: FC<{
    body?: string | JSX.Element
    customClass?: string
    hideCancel?: boolean
    confirmFn: (remember?: boolean) => void
    confirmText?: string
    confirmButtonWidth?: ButtonWidth

    cancelText?: string
    cancelFn?: (remember?: boolean) => void
    cancelButtonWidth?: ButtonWidth

    onCancel?: () => void

    showRememberSetting?: boolean
    rememberSettingLabel?: string
}> = ({
    body,
    customClass,

    confirmFn,
    confirmText,
    confirmButtonWidth,

    cancelText,
    cancelFn,
    cancelButtonWidth,

    onCancel,

    showRememberSetting = false,
    rememberSettingLabel,
    hideCancel = false
}) => {
    const modalData = useModalContext()
    const { t } = useTranslation()

    const [rememberSelection, setRememberSelection] = useState(false)

    const handleCancel = () => {
        if (cancelFn) {
            cancelFn(rememberSelection)
            return
        }

        if (onCancel) {
            onCancel()
            return
        }

        modalData.clearModal()
    }

    const handleConfirm = () => {
        confirmFn(rememberSelection)
        modalData.clearModal()
    }

    return (
        <div className={`confirmModal ${customClass ?? ''}`}>
            {body ? <div className='confirmModal__body'>{body}</div> : null}

            {showRememberSetting && (
                <label className='confirmModal__remember'>
                    <input
                        type='checkbox'
                        checked={rememberSelection}
                        onChange={e => setRememberSelection(e.target.checked)}
                    />
                    <span>{rememberSettingLabel ?? t('rememberMySetting')}</span>
                </label>
            )}

            <div className='confirmModal__actions'>
                {!hideCancel && (
                    <Button
                        text={cancelText ?? t('cancel')}
                        color='grey'
                        font='mont-14-normal'
                        width={cancelButtonWidth ?? '13'}
                        height='3'
                        clickFn={handleCancel}
                    />
                )}

                <Button
                    text={confirmText ?? t('confirm')}
                    color={customClass === 'confirmModal--add-card' ? 'blue' : 'black'}
                    font='mont-14-normal'
                    width={confirmButtonWidth ?? '13'}
                    height='3'
                    clickFn={handleConfirm}
                />
            </div>
        </div>
    )
}

export default ConfirmModal
